import { shallow } from 'zustand/shallow';

/**
 * Subscribe to a zustand store with a selector + shallow equality, so a
 * component only re-renders when the specific fields it reads change
 * (instead of on any store field change).
 */
export function useShallowStore(useStore, selector) {
  return useStore(selector, shallow);
}
